<!-- main-content + container-fluid son los que dan el ancho y el padding
     dentro del layout de admin. Sin ellos el contenido se desborda. -->
<div class="main-content table-page table-page--compact table-page--dense sv">
  <div class="container-fluid">

  <!-- ===== Encabezado: una sola línea (título + chip + frase) ===== -->
  <section class="table-page__hero sv-hero">
    <div class="table-page__copy">
      <h1>
        <span class="material-icons sv-hero__icono">{{ esRh ? 'fact_check' : 'groups' }}</span>
        {{ titulo }}
        <!-- Sólo en «Mi equipo»: en Seguimiento RH la barra trae «Subir
             Excel de RH», que sí escribe saldos, y la columna Documento
             carga el de cada solicitud (15/10/2026). -->
        <span class="sv-hero__solo" *ngIf="!esRh">sólo consulta</span>
      </h1>
      <p>{{ subtitulo }}</p>
    </div>

    <!-- El año elige el calendario, las vacaciones y los permisos (año
         calendario). El saldo NO es del año: Personas enseña el periodo de
         aniversario de cada quien vigente a la fecha de referencia de ese
         año, y lo dice arriba de su tabla. -->
    <div class="table-page__toolbar-actions">
      <!-- Sólo en Seguimiento RH: RH sube aquí el Excel de cada área, con
           el mismo formato de hoja que el de Desarrollo. Es el mismo
           componente del Calendario → Configuración; al cargar se vuelve
           a pedir el seguimiento para enseñar los periodos recién
           guardados. En «Mi equipo» no sale. -->
      <app-carga-excel-vacaciones *ngIf="esRh" estilo="barra"
                                  (cargado)="cargar()"></app-carga-excel-vacaciones>
      <div class="sv-anio">
        <button type="button" class="sv-anio__btn" (click)="mueveAnio(-1)"
                matTooltip="Año anterior" matTooltipClass="sv-tip">
          <span class="material-icons">chevron_left</span>
        </button>
        <span class="sv-anio__txt" [matTooltip]="tipAnio" matTooltipClass="sv-tip">{{ anio }}</span>
        <button type="button" class="sv-anio__btn" (click)="mueveAnio(1)"
                matTooltip="Año siguiente" matTooltipClass="sv-tip">
          <span class="material-icons">chevron_right</span>
        </button>
      </div>
    </div>
  </section>

  <!-- ===== Pestañas y, en Calendario, la barra del mes en el mismo renglón ===== -->
  <div class="sv-fila">
  <div class="sv-tabs" role="tablist">
    <button type="button" class="sv-tab" role="tab"
            [class.is-activa]="pestana === 'calendario'"
            [attr.aria-selected]="pestana === 'calendario'"
            (click)="verPestana('calendario')">
      <span class="material-icons">calendar_month</span>
      Calendario
    </button>
    <button type="button" class="sv-tab" role="tab"
            [class.is-activa]="pestana === 'vacaciones'"
            [attr.aria-selected]="pestana === 'vacaciones'"
            (click)="verPestana('vacaciones')">
      <span class="material-icons">flight_takeoff</span>
      Vacaciones
      <span class="sv-tab__n" *ngIf="vacaciones.length">{{ vacaciones.length }}</span>
    </button>
    <button type="button" class="sv-tab" role="tab"
            [class.is-activa]="pestana === 'permisos'"
            [attr.aria-selected]="pestana === 'permisos'"
            (click)="verPestana('permisos')">
      <span class="material-icons">assignment_turned_in</span>
      Permisos
      <span class="sv-tab__n" *ngIf="permisos.length">{{ permisos.length }}</span>
    </button>
    <button type="button" class="sv-tab" role="tab"
            [class.is-activa]="pestana === 'personas'"
            [attr.aria-selected]="pestana === 'personas'"
            (click)="verPestana('personas')">
      <span class="material-icons">badge</span>
      Personas
      <span class="sv-tab__n" *ngIf="personas">{{ personas }}</span>
    </button>
  </div>

    <!-- Misma condición que el contenido del calendario: sólo hay mes
         que navegar cuando hay calendario que ver. -->
    <div class="sv-mesbar" *ngIf="pestana === 'calendario' && !cargando && !error && (esRh || personas)">
      <div class="sv-mesbar__nav">
        <button type="button" class="sv-anio__btn" (click)="mueveMes(-1)"
                matTooltip="Mes anterior" matTooltipClass="sv-tip">
          <span class="material-icons">chevron_left</span>
        </button>
        <span class="sv-mesbar__txt">{{ tituloMes }}</span>
        <button type="button" class="sv-anio__btn" (click)="mueveMes(1)"
                matTooltip="Mes siguiente" matTooltipClass="sv-tip">
          <span class="material-icons">chevron_right</span>
        </button>
      </div>
      <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
              (click)="irAHoy()">
        <span class="material-icons">today</span>
        Hoy
      </button>

      <div class="sv-mesbar__resumen">
        <span class="sv-dato">
          <b>{{ fueraEsteMes }}</b>
          {{ fueraEsteMes === 1 ? 'persona con vacaciones' : 'personas con vacaciones' }}
        </span>
        <span class="sv-dato">
          <b>{{ permisosEsteMes }}</b>
          {{ permisosEsteMes === 1 ? 'permiso' : 'permisos' }}
        </span>
      </div>
    </div>

    <!-- En Personas, en el lugar de la barra del mes: a qué día son los
         periodos que se ven. Es la misma fecha que usa el servidor. -->
    <div class="sv-mesbar" *ngIf="pestana === 'personas' && !cargando && !error && (esRh || personas)">
      <span class="sv-ref" [matTooltip]="tipReferencia" matTooltipClass="sv-tip">
        <span class="material-icons">event_available</span>
        Periodos vigentes al <b>{{ fechaDma(fechaRef) }}</b>
      </span>
    </div>
  </div>

  <!-- ===== Estados ===== -->
  <div class="sv-aviso sv-aviso--error" *ngIf="error">
    <span class="material-icons">error_outline</span>
    {{ error }}
  </div>

  <div class="sv-cargando" *ngIf="cargando">
    <span class="material-icons sv-cargando__icono">hourglass_top</span>
    Consultando…
  </div>

  <!-- Un líder al que todavía no le han asignado a nadie: se dice, en
       vez de enseñar cuatro pestañas vacías sin explicación. -->
  <section class="table-page__card" *ngIf="!cargando && !error && !esRh && !personas">
    <div class="table-page__empty">
      <span class="material-icons sv-vacio__icono">group_off</span>
      <!-- El equipo sale de los periodos vigentes a la fecha de referencia,
           no del año: por eso se dice la fecha. -->
      <p>Al {{ fechaDma(fechaRef) }} no autorizas las vacaciones de nadie.</p>
      <p class="sv-vacio__nota">
        Quién autoriza a quién se configura en Calendario → Configuración.
      </p>
    </div>
  </section>

  <ng-container *ngIf="!cargando && !error && (esRh || personas)">

  <!-- ==================== CALENDARIO ====================
       La barra del mes vive arriba, junto a las pestañas. La rejilla
       no se toca. -->
  <ng-container *ngIf="pestana === 'calendario'">
    <div class="sv-tabla-caja">
      <table class="sv-cal">
        <thead>
          <!-- Sólo de lunes a viernes: el fin de semana no se trabaja. -->
          <tr>
            <th *ngFor="let d of encabezadosCal">{{ d }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let semana of semanas">
            <td *ngFor="let dia of semana"
                class="sv-cal__dia"
                [class.es-festivo]="dia.esFestivo"
                [class.es-hoy]="dia.esHoy"
                [class.es-vacia]="!dia.numero">
              <span class="sv-cal__num" *ngIf="dia.numero">
                <span class="sv-cal__n">{{ dia.numero }}</span>
                <span class="sv-cal__festivo" *ngIf="dia.esFestivo"
                      matTooltip="Día festivo" matTooltipClass="sv-tip">festivo</span>
              </span>

              <!-- Vacaciones: una franja por persona, en su color. -->
              <span class="sv-cal__tag" *ngFor="let v of dia.vacaciones"
                    [class.es-pendiente]="v.estatus === 'PENDIENTE'"
                    [style.background]="tinte(v.color, 0.14)"
                    [style.borderColor]="v.estatus === 'PENDIENTE' ? v.color : tinte(v.color, 0.34)"
                    [style.color]="v.color"
                    [matTooltip]="v.colaborador + ' · ' + textoRango(v) +
                      (v.estatus === 'PENDIENTE' ? ' · esperando respuesta' : ' · autorizada')"
                    matTooltipClass="sv-tip">
                {{ v.colaborador }}
              </span>

              <!-- Permisos: un punto en un solo día, con el icono del tipo. -->
              <span class="sv-cal__per" *ngFor="let p of dia.permisos"
                    [class.es-pendiente]="p.estatus === 'PENDIENTE'"
                    [matTooltip]="p.colaborador + ' · ' + textoTipo(p) +
                      (p.estatus === 'PENDIENTE' ? ' · esperando respuesta' : ' · autorizado')"
                    matTooltipClass="sv-tip">
                <span class="material-icons">{{ iconoTipo(p) }}</span>
                {{ p.colaborador }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- La leyenda con muestras y en tinta oscura (pedido de Norman,
         24/09/2026: «nada gris, esto no se ve»). Antes era un párrafo gris
         claro sobre el fondo gris de la página. -->
    <div class="sv-leyenda" aria-label="Qué significa cada cosa del calendario">
      <span class="sv-leyenda__item">
        <span class="sv-leyenda__mues sv-leyenda__mues--vac" aria-hidden="true"></span>
        Vacaciones autorizadas
      </span>
      <span class="sv-leyenda__item">
        <span class="sv-leyenda__mues sv-leyenda__mues--vac sv-leyenda__mues--espera" aria-hidden="true"></span>
        Esperan respuesta (borde punteado)
      </span>
      <span class="sv-leyenda__item">
        <span class="sv-leyenda__mues sv-leyenda__mues--per" aria-hidden="true">
          <span class="material-icons">schedule</span>
        </span>
        Permiso
      </span>
      <span class="sv-leyenda__item">
        <span class="sv-leyenda__mues sv-leyenda__mues--festivo" aria-hidden="true"></span>
        Festivo
      </span>
      <span class="sv-leyenda__item">
        <span class="sv-leyenda__mues sv-leyenda__mues--hoy" aria-hidden="true">{{ hoyDia }}</span>
        Hoy
      </span>
      <span class="sv-leyenda__nota">De lunes a viernes: el fin de semana y los festivos no se trabajan ni se descuentan.</span>
    </div>
  </ng-container>

  <!-- ==================== VACACIONES ==================== -->
  <ng-container *ngIf="pestana === 'vacaciones'">
    <section class="table-page__card">
    <div class="table-page__toolbar table-page__toolbar--filters">
      <div class="table-page__filters-grid">
      <div class="sv-pills">
        <button type="button" class="sv-pill" [class.is-activa]="!fEstatusVac"
                (click)="fEstatusVac = ''; filtraVacaciones()">
          Todas <span class="sv-pill__n">{{ vacaciones.length }}</span>
        </button>
        <button type="button" class="sv-pill" *ngFor="let e of ESTATUS_VAC"
                [class.is-activa]="fEstatusVac === e.valor"
                [style.borderColor]="fEstatusVac === e.valor ? e.color : null"
                [style.color]="fEstatusVac === e.valor ? e.color : null"
                (click)="fEstatusVac = e.valor; filtraVacaciones()">
          <span class="sv-pill__punto" [style.background]="e.color"></span>
          {{ e.texto }}
          <span class="sv-pill__n">{{ cuantasVac(e.valor) }}</span>
        </button>
      </div>
        <div class="table-page__filter table-page__filter--wide">
          <mat-form-field appearance="outline" class="table-page__field">
            <mat-label>Buscar persona, área o motivo</mat-label>
            <input matInput aria-label="Buscar persona, área o motivo" type="search"
                   [(ngModel)]="fTextoVac" name="fTextoVac" (ngModelChange)="filtraVacaciones()">
          </mat-form-field>
        </div>
      </div>
      <div class="table-page__toolbar-actions">
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                *ngIf="hayFiltroVac" (click)="limpiaVac()">
          <span class="material-icons">filter_alt_off</span>
          Quitar filtros
        </button>
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                (click)="exportaVacaciones()" [disabled]="!vacFiltradas.length"
                matTooltip="Baja lo que se está viendo, en CSV" matTooltipClass="sv-tip">
          <span class="material-icons">download</span>
          Exportar
        </button>
      </div>
    </div>

    <div class="table-page__table-wrap" *ngIf="vacFiltradas.length">
      <table class="table-page__table sv-tabla">
        <thead>
          <tr>
            <th>Colaborador</th>
            <th>Área</th>
            <!-- «Fechas» y no «Periodo»: periodo es ya el del aniversario
                 (pestaña Personas), y esto es lo que duran las vacaciones. -->
            <th>Fechas</th>
            <th class="c">Días</th>
            <th class="c">Estatus</th>
            <th>Resolvió</th>
            <th class="c table-page__actions-head table-page__actions--multi" *ngIf="esRh">Documento</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let v of vacPagina; trackBy: trackVacacion">
            <td>
              <span class="sv-persona">
                <span class="sv-persona__punto" [style.background]="v.color || '#0369a1'"></span>
                <span class="sv-persona__nombre" [matTooltip]="v.colaborador || ''"
                      matTooltipClass="sv-tip">{{ v.colaborador }}</span>
              </span>
            </td>
            <td>
              <span class="sv-area" [matTooltip]="areaDe(v.idUsuario)" matTooltipClass="sv-tip">
                {{ areaDe(v.idUsuario) || '—' }}
              </span>
            </td>
            <td>
              <span class="sv-rango">{{ textoRango(v) }}</span>
              <span class="sv-origen">{{ v.origen === 'SOLICITUD' ? 'la pidió' : 'capturada' }}</span>
            </td>
            <td class="c">{{ diasHabiles(v) }}</td>
            <td class="c">
              <span class="sv-estado"
                    [style.background]="tinte(colorVac(v.estatus), 0.12)"
                    [style.borderColor]="tinte(colorVac(v.estatus), 0.35)"
                    [style.color]="colorVac(v.estatus)">
                {{ etiquetaVac(v.estatus) }}
              </span>
            </td>
            <td>
              <span class="sv-quien" *ngIf="resolucion(v); else sinResolverV">{{ resolucion(v) }}</span>
              <ng-template #sinResolverV>
                <span class="sv-falta">{{ v.estatus === 'PENDIENTE' ? 'esperando' : '—' }}</span>
              </ng-template>
              <span class="sv-motivo" *ngIf="v.motivo">
                <span class="material-icons">chat_bubble_outline</span>
                {{ v.motivo }}
              </span>
            </td>
            <!-- El documento, sólo en Seguimiento RH (15/10/2026): el PDF del
                 FRC-019 si se firmó al pedir, y lo que se subió (ver abre el
                 historial: quién y cuándo, y descargar). RH carga en lo vivo,
                 pedido o capturado, aunque no haya papel; lo negado o
                 retirado sólo se consulta, y en lo suyo no se le ofrece. -->
            <td class="c table-page__actions table-page__actions--multi" *ngIf="esRh">
              <div class="table-page__action-group">
                <button type="button" class="table-page__action-btn" *ngIf="vacacionConFrc(v)"
                        [disabled]="generandoFrc === 'V' + v.idVacacion"
                        (click)="frcVacacion(v)" aria-label="Bajar el FRC-019"
                        matTooltip="Bajar el FRC-019" matTooltipClass="sv-tip">
                  <span class="material-icons" aria-hidden="true">picture_as_pdf</span>
                </button>
                <app-frc-firmado variante="icono"
                                 tipo="VACACION"
                                 [id]="v.idVacacion"
                                 [enPapel]="!!v.enPapel"
                                 [firmado]="v.firmado"
                                 [gestiona]="true"
                                 [puedeSubir]="rhCargaVacacion(v, miId)"
                                 (cambio)="v.firmado = $event"></app-frc-firmado>
                <span class="sv-falta" *ngIf="sinDocVac(v)">—</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-page__footer" *ngIf="vacFiltradas.length">
      <div class="table-page__meta">
        <span class="sv-cuenta">
          <b>{{ vacFiltradas.length }}</b>
          {{ vacFiltradas.length === 1 ? 'solicitud' : 'solicitudes' }}
          <ng-container *ngIf="hayFiltroVac">de {{ vacaciones.length }}</ng-container>
          en {{ anio }}
        </span>
        <span *ngIf="totalPaginas(vacFiltradas.length) > 1">{{ rango(paginaVac, vacFiltradas.length) }}</span>
      </div>
      <nav class="table-page__pager" aria-label="Paginación" *ngIf="totalPaginas(vacFiltradas.length) > 1">
        <button type="button" class="table-page__pager-link" title="Primera página" aria-label="Primera página"
                [disabled]="paginaVac <= 1" (click)="paginaVac = 1">
          <span class="material-icons">first_page</span>
        </button>
        <button type="button" class="table-page__pager-link" title="Página anterior" aria-label="Página anterior"
                [disabled]="paginaVac <= 1" (click)="paginaVac = paginaVac - 1">
          <span class="material-icons">chevron_left</span>
        </button>
        <span class="table-page__pager-page is-current">{{ paginaVac }}</span>
        <button type="button" class="table-page__pager-link" title="Página siguiente" aria-label="Página siguiente"
                [disabled]="paginaVac >= totalPaginas(vacFiltradas.length)" (click)="paginaVac = paginaVac + 1">
          <span class="material-icons">chevron_right</span>
        </button>
        <button type="button" class="table-page__pager-link" title="Última página" aria-label="Última página"
                [disabled]="paginaVac >= totalPaginas(vacFiltradas.length)"
                (click)="paginaVac = totalPaginas(vacFiltradas.length)">
          <span class="material-icons">last_page</span>
        </button>
      </nav>
    </div>

    <div class="table-page__empty" *ngIf="!vacFiltradas.length">
      <span class="material-icons sv-vacio__icono">{{ hayFiltroVac ? 'search_off' : 'flight_takeoff' }}</span>
      <p *ngIf="hayFiltroVac">Nada coincide con esos filtros.</p>
      <p *ngIf="!hayFiltroVac">No hay solicitudes de vacaciones en {{ anio }}.</p>
    </div>
    </section>
  </ng-container>

  <!-- ==================== PERMISOS ==================== -->
  <ng-container *ngIf="pestana === 'permisos'">
    <section class="table-page__card">
    <div class="table-page__toolbar table-page__toolbar--filters">
      <div class="table-page__filters-grid">
      <div class="sv-pills">
        <button type="button" class="sv-pill" [class.is-activa]="!fEstatusPer"
                (click)="fEstatusPer = ''; filtraPermisos()">
          Todos <span class="sv-pill__n">{{ permisos.length }}</span>
        </button>
        <button type="button" class="sv-pill" *ngFor="let e of ESTATUS_PER"
                [class.is-activa]="fEstatusPer === e.valor"
                [style.borderColor]="fEstatusPer === e.valor ? e.color : null"
                [style.color]="fEstatusPer === e.valor ? e.color : null"
                (click)="fEstatusPer = e.valor; filtraPermisos()">
          <span class="sv-pill__punto" [style.background]="e.color"></span>
          {{ e.texto }}
          <span class="sv-pill__n">{{ cuantosPer(e.valor) }}</span>
        </button>
      </div>
        <div class="table-page__filter table-page__filter--narrow">
          <mat-form-field appearance="outline" class="table-page__field">
            <mat-label>Tipo</mat-label>
            <mat-select [(ngModel)]="fTipoPer" name="fTipoPer" (ngModelChange)="filtraPermisos()">
              <mat-option value="">Todos los tipos</mat-option>
              <mat-option *ngFor="let t of TIPOS" [value]="t.valor">{{ t.texto }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="table-page__filter table-page__filter--wide">
          <mat-form-field appearance="outline" class="table-page__field">
            <mat-label>Buscar persona, área o motivo</mat-label>
            <input matInput aria-label="Buscar persona, área o motivo" type="search"
                   [(ngModel)]="fTextoPer" name="fTextoPer" (ngModelChange)="filtraPermisos()">
          </mat-form-field>
        </div>
      </div>
      <div class="table-page__toolbar-actions">
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                *ngIf="hayFiltroPer" (click)="limpiaPer()">
          <span class="material-icons">filter_alt_off</span>
          Quitar filtros
        </button>
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                (click)="exportaPermisos()" [disabled]="!perFiltrados.length"
                matTooltip="Baja lo que se está viendo, en CSV" matTooltipClass="sv-tip">
          <span class="material-icons">download</span>
          Exportar
        </button>
      </div>
    </div>

    <div class="table-page__table-wrap" *ngIf="perFiltrados.length">
      <table class="table-page__table sv-tabla">
        <thead>
          <tr>
            <th class="sv-tabla__dia">Día</th>
            <th>Colaborador</th>
            <th>Permiso</th>
            <th class="c">Goce</th>
            <th class="c">Estatus</th>
            <th>Resolvió</th>
            <th class="c table-page__actions-head table-page__actions--multi" *ngIf="esRh">Documento</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of perPagina; trackBy: trackPermiso">
            <td class="sv-tabla__dia">{{ fechaCorta(p.fecha) }}</td>
            <td>
              <span class="sv-persona">
                <span class="sv-persona__nombre" [matTooltip]="p.colaborador || ''"
                      matTooltipClass="sv-tip">{{ p.colaborador }}</span>
              </span>
              <span class="sv-origen" *ngIf="p.area || areaDe(p.idUsuario)">{{ p.area || areaDe(p.idUsuario) }}</span>
            </td>
            <td>
              <span class="sv-que">
                <span class="material-icons">{{ iconoTipo(p) }}</span>
                {{ textoTipo(p) }}
              </span>
              <span class="sv-nota" *ngIf="p.observaciones" [matTooltip]="p.observaciones"
                    matTooltipClass="sv-tip">{{ p.observaciones }}</span>
            </td>
            <td class="c">
              <span *ngIf="p.goce; else sinGoce">{{ p.goce === 'CON' ? 'Con goce' : 'Sin goce' }}</span>
              <ng-template #sinGoce><span class="sv-falta">—</span></ng-template>
            </td>
            <td class="c">
              <span class="sv-estado"
                    [style.background]="tinte(colorPer(p.estatus), 0.12)"
                    [style.borderColor]="tinte(colorPer(p.estatus), 0.35)"
                    [style.color]="colorPer(p.estatus)">
                {{ etiquetaPer(p.estatus) }}
              </span>
            </td>
            <td>
              <span class="sv-quien" *ngIf="resolucionPer(p); else sinResolverP">{{ resolucionPer(p) }}</span>
              <ng-template #sinResolverP>
                <span class="sv-falta">{{ p.estatus === 'PENDIENTE' ? 'esperando' : '—' }}</span>
              </ng-template>
              <span class="sv-motivo" *ngIf="p.motivo">
                <span class="material-icons">chat_bubble_outline</span>
                {{ p.motivo }}
              </span>
            </td>
            <!-- Igual que en Vacaciones, con el FRC-017 (15/10/2026). -->
            <td class="c table-page__actions table-page__actions--multi" *ngIf="esRh">
              <div class="table-page__action-group">
                <button type="button" class="table-page__action-btn" *ngIf="permisoConFrc(p)"
                        [disabled]="generandoFrc === 'P' + p.idPermiso"
                        (click)="frcPermiso(p)" aria-label="Bajar el FRC-017"
                        matTooltip="Bajar el FRC-017" matTooltipClass="sv-tip">
                  <span class="material-icons" aria-hidden="true">picture_as_pdf</span>
                </button>
                <app-frc-firmado variante="icono"
                                 tipo="PERMISO"
                                 [id]="p.idPermiso"
                                 [enPapel]="!!p.enPapel"
                                 [firmado]="p.firmado"
                                 [gestiona]="true"
                                 [puedeSubir]="rhCargaPermiso(p, miId)"
                                 (cambio)="p.firmado = $event"></app-frc-firmado>
                <span class="sv-falta" *ngIf="sinDocPer(p)">—</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-page__footer" *ngIf="perFiltrados.length">
      <div class="table-page__meta">
        <span class="sv-cuenta">
          <b>{{ perFiltrados.length }}</b>
          {{ perFiltrados.length === 1 ? 'permiso' : 'permisos' }}
          <ng-container *ngIf="hayFiltroPer">de {{ permisos.length }}</ng-container>
          en {{ anio }}
        </span>
        <span *ngIf="totalPaginas(perFiltrados.length) > 1">{{ rango(paginaPer, perFiltrados.length) }}</span>
      </div>
      <nav class="table-page__pager" aria-label="Paginación" *ngIf="totalPaginas(perFiltrados.length) > 1">
        <button type="button" class="table-page__pager-link" title="Primera página" aria-label="Primera página"
                [disabled]="paginaPer <= 1" (click)="paginaPer = 1">
          <span class="material-icons">first_page</span>
        </button>
        <button type="button" class="table-page__pager-link" title="Página anterior" aria-label="Página anterior"
                [disabled]="paginaPer <= 1" (click)="paginaPer = paginaPer - 1">
          <span class="material-icons">chevron_left</span>
        </button>
        <span class="table-page__pager-page is-current">{{ paginaPer }}</span>
        <button type="button" class="table-page__pager-link" title="Página siguiente" aria-label="Página siguiente"
                [disabled]="paginaPer >= totalPaginas(perFiltrados.length)" (click)="paginaPer = paginaPer + 1">
          <span class="material-icons">chevron_right</span>
        </button>
        <button type="button" class="table-page__pager-link" title="Última página" aria-label="Última página"
                [disabled]="paginaPer >= totalPaginas(perFiltrados.length)"
                (click)="paginaPer = totalPaginas(perFiltrados.length)">
          <span class="material-icons">last_page</span>
        </button>
      </nav>
    </div>

    <div class="table-page__empty" *ngIf="!perFiltrados.length">
      <span class="material-icons sv-vacio__icono">{{ hayFiltroPer ? 'search_off' : 'assignment_turned_in' }}</span>
      <p *ngIf="hayFiltroPer">Nada coincide con esos filtros.</p>
      <p *ngIf="!hayFiltroPer">No hay permisos en {{ anio }}.</p>
    </div>
    </section>
  </ng-container>

  <!-- ==================== PERSONAS ==================== -->
  <ng-container *ngIf="pestana === 'personas'">
    <section class="table-page__card">
    <div class="table-page__toolbar table-page__toolbar--filters">
      <div class="table-page__filters-grid">
        <!-- Área y antigüedad (pedido de Norman, 24/09/2026), como el «Tipo»
             de Permisos. Sólo salen las opciones que existen, con cuántos
             hay; la antigüedad va por tramos de ley, que son los que
             deciden los días. -->
        <div class="table-page__filter table-page__filter--medium">
          <mat-form-field appearance="outline" class="table-page__field">
            <mat-label>Área</mat-label>
            <mat-select [(ngModel)]="fAreaPersona" name="fAreaPersona" (ngModelChange)="filtraPersonas()">
              <!-- Los números cuentan con la antigüedad y la búsqueda ya
                   puestas; la que daría cero va apagada. -->
              <mat-option value="">Todas las áreas ({{ totalAreasPersonas }})</mat-option>
              <mat-option *ngFor="let a of areasPersonas" [value]="a.valor"
                          [disabled]="!a.n && a.valor !== fAreaPersona">{{ a.texto }} ({{ a.n }})</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="table-page__filter table-page__filter--medium">
          <mat-form-field appearance="outline" class="table-page__field">
            <mat-label>Antigüedad</mat-label>
            <mat-select [(ngModel)]="fAntigPersona" name="fAntigPersona" (ngModelChange)="filtraPersonas()">
              <mat-option value="">Toda antigüedad</mat-option>
              <mat-option *ngFor="let t of antigPersonas" [value]="t.valor"
                          [disabled]="!t.n && t.valor !== fAntigPersona">{{ t.texto }} ({{ t.n }})</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="table-page__filter table-page__filter--wide">
          <mat-form-field appearance="outline" class="table-page__field">
            <mat-label>{{ esRh ? 'Buscar persona, área o quien autoriza' : 'Buscar persona o área' }}</mat-label>
            <input matInput [attr.aria-label]="esRh ? 'Buscar persona, área o quien autoriza' : 'Buscar persona o área'" type="search"
                   [(ngModel)]="fTextoPersona" name="fTextoPersona" (ngModelChange)="filtraPersonas()">
          </mat-form-field>
        </div>
      </div>
      <div class="table-page__toolbar-actions">
        <!-- Siempre en su lugar y sólo invisible sin filtros (visibility:
             ni se enfoca ni lo lee el lector): con *ngIf, al aparecer
             encogía Área, Antigüedad y el buscador y los campos brincaban. -->
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                [style.visibility]="hayFiltroPersona ? null : 'hidden'" (click)="limpiaPersonas()">
          <span class="material-icons">filter_alt_off</span>
          Quitar filtros
        </button>
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                (click)="exportaPersonas()" [disabled]="!personasFiltradas.length"
                matTooltip="Baja lo que se está viendo en CSV, con las columnas de la hoja de RH"
                matTooltipClass="sv-tip">
          <span class="material-icons">download</span>
          Exportar
        </button>
      </div>
    </div>

    <!-- Las columnas de la hoja de RH, en su orden, para cuadrarla persona
         por persona. Los números los manda el servidor ya calculados
         (restantes, acumulado, le quedan): aquí no se rehace ninguna
         cuenta de periodos. -->
    <div class="table-page__table-wrap" *ngIf="personasFiltradas.length">
      <table class="table-page__table table-page__table--wide sv-tabla">
        <thead>
          <tr>
            <th>Colaborador</th>
            <th>Área</th>
            <th class="c">Alta IMSS</th>
            <th>Periodo</th>
            <th class="c">Antigüedad</th>
            <th class="c">Días de goce</th>
            <th class="c">Gozados</th>
            <th class="c">Restantes</th>
            <th class="c">Acumulado</th>
            <th class="c">Le quedan</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let s of personasPagina; trackBy: trackSaldo"
              [class.es-baja]="s.usuarioActivo === false">
            <!-- Quién autoriza va debajo del nombre y sólo en RH: en «Mi
                 equipo» diría en cada renglón el nombre de quien mira. -->
            <td>
              <span class="sv-persona">
                <span class="sv-persona__nombre" [matTooltip]="s.colaborador || ''"
                      matTooltipClass="sv-tip">{{ s.colaborador }}</span>
              </span>
              <span class="sv-origen" *ngIf="s.usuarioActivo === false; else conAutoriza">dado de baja</span>
              <ng-template #conAutoriza>
                <span class="sv-origen" *ngIf="esRh">
                  {{ s.autorizaNombre ? 'autoriza ' + s.autorizaNombre : 'sin autorizador' }}
                </span>
              </ng-template>
            </td>
            <td><span class="sv-area" [matTooltip]="s.area || ''" matTooltipClass="sv-tip">{{ s.area || '—' }}</span></td>
            <td class="c">
              <span class="sv-fecha" *ngIf="s.fechaIngreso; else sinAlta">{{ fechaDma(s.fechaIngreso) }}</span>
              <ng-template #sinAlta><span class="sv-falta" matTooltip="RH todavía no captura su Alta IMSS"
                                          matTooltipClass="sv-tip">—</span></ng-template>
            </td>
            <!-- Como la hoja de RH: «al» el aniversario siguiente. El último
                 día que de verdad cuenta va en el tooltip. -->
            <td>
              <span class="sv-periodo" [class.es-calendario]="!s.porAniversario"
                    [matTooltip]="tipPeriodo(s)" matTooltipClass="sv-tip">{{ textoPeriodo(s) }}</span>
              <span class="sv-aniv" *ngIf="avisoAniversario(s)"
                    [matTooltip]="tipAniversario(s)" matTooltipClass="sv-tip">{{ avisoAniversario(s) }}</span>
            </td>
            <td class="c">
              <span *ngIf="antiguedadTexto(s); else sinAntiguedad"
                    matTooltip="Años cumplidos al empezar el periodo" matTooltipClass="sv-tip">{{ antiguedadTexto(s) }}</span>
              <ng-template #sinAntiguedad><span class="sv-falta" [matTooltip]="tipSinAntiguedad(s)"
                                                matTooltipClass="sv-tip">—</span></ng-template>
            </td>
            <td class="c">
              <span *ngIf="s.diasTotales != null; else sinDias"
                    [matTooltip]="tipGoce(s)" matTooltipClass="sv-tip">{{ s.diasTotales }}</span>
              <ng-template #sinDias><span class="sv-falta" matTooltip="Todavía no se le asignan días"
                                          matTooltipClass="sv-tip">—</span></ng-template>
            </td>
            <!-- Lo de COS más lo que traía la hoja de RH, que no tiene
                 fechas: el tooltip desglosa los dos sumandos. -->
            <td class="c">
              <span [matTooltip]="desgloseGozados(s)"
                    matTooltipClass="sv-tip">{{ gozados(s) }}</span>
            </td>
            <td class="c">
              <span *ngIf="restantes(s) != null; else sinDias2"
                    [class.es-negativo]="(restantes(s) || 0) < 0">{{ restantes(s) }}</span>
              <ng-template #sinDias2><span class="sv-falta">—</span></ng-template>
            </td>
            <!-- El reloj marca el acumulado que salió solo de su periodo
                 anterior; sin él, lo fijó RH. En cero no va: el servidor
                 marca «calculado» también a quien no tiene periodo anterior. -->
            <td class="c">
              <span class="sv-acum" [class.es-negativo]="acumulado(s) < 0"
                    [matTooltip]="tipAcumulado(s)" matTooltipClass="sv-tip">
                {{ acumulado(s) }}
                <span class="material-icons sv-acum__icono" *ngIf="s.arrastreCalculado && acumulado(s)">history</span>
              </span>
            </td>
            <td class="c">
              <b *ngIf="quedan(s) != null; else sinDias3"
                 [class.es-cero]="quedan(s) === 0" [class.es-negativo]="(quedan(s) || 0) < 0"
                 [matTooltip]="desgloseQuedan(s)" matTooltipClass="sv-tip">
                {{ quedan(s) }}
              </b>
              <ng-template #sinDias3><span class="sv-falta">—</span></ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-page__footer" *ngIf="personasFiltradas.length">
      <div class="table-page__meta">
        <span class="sv-cuenta">
          <b>{{ personasFiltradas.length }}</b>
          {{ personasFiltradas.length === 1 ? 'persona' : 'personas' }}
          <ng-container *ngIf="hayFiltroPersona">de {{ saldos.length }}</ng-container>
        </span>
        <span *ngIf="totalPaginas(personasFiltradas.length) > 1">{{ rango(paginaPersona, personasFiltradas.length) }}</span>
      </div>
      <nav class="table-page__pager" aria-label="Paginación" *ngIf="totalPaginas(personasFiltradas.length) > 1">
        <button type="button" class="table-page__pager-link" title="Primera página" aria-label="Primera página"
                [disabled]="paginaPersona <= 1" (click)="paginaPersona = 1">
          <span class="material-icons">first_page</span>
        </button>
        <button type="button" class="table-page__pager-link" title="Página anterior" aria-label="Página anterior"
                [disabled]="paginaPersona <= 1" (click)="paginaPersona = paginaPersona - 1">
          <span class="material-icons">chevron_left</span>
        </button>
        <span class="table-page__pager-page is-current">{{ paginaPersona }}</span>
        <button type="button" class="table-page__pager-link" title="Página siguiente" aria-label="Página siguiente"
                [disabled]="paginaPersona >= totalPaginas(personasFiltradas.length)"
                (click)="paginaPersona = paginaPersona + 1">
          <span class="material-icons">chevron_right</span>
        </button>
        <button type="button" class="table-page__pager-link" title="Última página" aria-label="Última página"
                [disabled]="paginaPersona >= totalPaginas(personasFiltradas.length)"
                (click)="paginaPersona = totalPaginas(personasFiltradas.length)">
          <span class="material-icons">last_page</span>
        </button>
      </nav>
    </div>

    <div class="table-page__empty" *ngIf="!personasFiltradas.length">
      <span class="material-icons sv-vacio__icono">{{ hayFiltroPersona ? 'search_off' : 'badge' }}</span>
      <p *ngIf="hayFiltroPersona">Nadie coincide con esos filtros.</p>
      <p *ngIf="!hayFiltroPersona">Nadie tiene un periodo vigente al {{ fechaDma(fechaRef) }}.</p>
    </div>
    </section>

    <!-- Cómo se leen las columnas: son las de la hoja de RH, y lo del
         acumulado es lo que más se pregunta. -->
    <p class="sv-pie" *ngIf="personasFiltradas.length">
      Gozados son los que tomó en COS (contando lo que espera respuesta) más
      los que ya traía la hoja de RH. Le quedan = restantes + acumulado. Lo que
      no tome antes de su aniversario se acumula a su siguiente periodo;
      <span class="material-icons sv-pie__icono">history</span> marca el
      acumulado que salió solo de su periodo anterior.
    </p>
  </ng-container>

  </ng-container>

  </div>
</div>
